<mat-toolbar matDialogTitle class="mat-primary m-0">
  <mat-toolbar-row class="flex">
    <span class="dialog-title flex-1 truncate">Reset Application</span>
    <button
      class="close-icon"
      mat-icon-button
      (click)="matDialogRef.close()"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="pt-8 max-w-128">
  <div
    class="text-lg tracking-tight text-tilled-secondary break-normal w-full pb-6 text-center"
  >
    This will clear DocuSign e-signature data and ELAPP configuration, returning
    the application to its initial started state. The merchant will need to
    re-submit their application.
  </div>

  <div
    class="text-lg font-bold tracking-tight text-tilled-secondary break-normal w-full pb-6 text-center"
  >
    Are you sure you want to continue?
  </div>

  <div class="flex w-full justify-end">
    <!-- Cancel button -->
    <button class="mr-4" mat-button (click)="cancelClicked()">Cancel</button>
    <!-- Reset button -->
    <button mat-flat-button color="warn" (click)="submitClicked()">
      <span>Reset Application</span>
    </button>
  </div>
</div>
